export default __webpack_public_path__ + "static/media/tecnologia.e73c1459.jpg";